import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail } from 'lucide-react';
export function ContactSection() {
  return <section id="contact" className="py-24 md:py-32 bg-bg-warm relative" data-id="element-42">
      <div className="max-w-7xl mx-auto px-4 md:px-6" data-id="element-43">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24" data-id="element-44">
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          ease: [0.16, 1, 0.3, 1]
        }} className="flex flex-col space-y-12" data-id="element-45">
            <div data-id="element-46">
              <div className="flex items-center space-x-4 mb-6" data-id="element-47">
                <span className="h-px w-12 bg-accent block" data-id="element-48"></span>
                <span className="text-accent uppercase tracking-widest text-sm font-light" data-id="element-49">
                  Get in Touch
                </span>
              </div>

              <h2 className="text-3xl md:text-4xl lg:text-5xl font-light text-primary leading-tight tracking-tight" data-id="element-50">
                Start a <span className="text-accent" data-id="element-51">Conversation</span>
              </h2>
            </div>

            <div className="space-y-8" data-id="element-52">
              {[{
              icon: MapPin,
              title: 'Visit Us',
              lines: ['906 Prime Land Towers,', 'Venture Street, Madrigal Business Park,', 'Ayala Alabang, Muntinlupa City 1780']
            }, {
              icon: Phone,
              title: 'Call Us',
              lines: ['+63 2 8123 4567', 'Mon-Fri, 9am - 6pm PHT']
            }, {
              icon: Mail,
              title: 'Email Us',
              lines: ['info@jrpdi.com.ph', 'careers@jrpdi.com.ph']
            }].map(item => <div key={item.title} className="flex items-start space-x-5 group" data-id="element-53">
                  <div className="text-accent mt-1" data-id="element-54">
                    <item.icon size={22} strokeWidth={1.5} data-id="element-55" />
                  </div>
                  <div data-id="element-56">
                    <h4 className="text-sm uppercase tracking-widest font-normal text-primary mb-2" data-id="element-57">
                      {item.title}
                    </h4>
                    <p className="text-text-muted font-light" data-id="element-58">
                      {item.lines.map((line, i) => <Fragment key={i} data-id="element-59">
                          {line}
                          {i < item.lines.length - 1 && <br data-id="element-60" />}
                        </Fragment>)}
                    </p>
                  </div>
                </div>)}
            </div>
          </motion.div>

          {/* Glass Contact Form */}
          <motion.div initial={{
          opacity: 0,
          y: 50
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: [0.16, 1, 0.3, 1]
        }} className="bg-transparent p-8 md:p-12 relative overflow-hidden" data-id="element-61">
            <h3 className="text-2xl font-light text-primary mb-8 relative z-10" data-id="element-62">
              Send us a message
            </h3>

            <form className="space-y-6 relative z-10" onSubmit={e => e.preventDefault()} data-id="element-63">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-64">
                <div className="space-y-2" data-id="element-65">
                  <label htmlFor="name" className="text-xs uppercase tracking-widest text-text-muted font-light" data-id="element-66">
                    Full Name
                  </label>
                  <input type="text" id="name" className="w-full bg-transparent border-0 border-b border-neutral-300 py-3 px-0 text-primary font-light focus:outline-none focus:border-accent transition-colors placeholder:text-neutral-400 rounded-none" placeholder="John Doe" data-id="element-67" />
                </div>
                <div className="space-y-2" data-id="element-68">
                  <label htmlFor="email" className="text-xs uppercase tracking-widest text-text-muted font-light" data-id="element-69">
                    Email Address
                  </label>
                  <input type="email" id="email" className="w-full bg-transparent border-0 border-b border-neutral-300 py-3 px-0 text-primary font-light focus:outline-none focus:border-accent transition-colors placeholder:text-neutral-400 rounded-none" placeholder="john@example.com" data-id="element-70" />
                </div>
              </div>

              <div className="space-y-2" data-id="element-71">
                <label htmlFor="phone" className="text-xs uppercase tracking-widest text-text-muted font-light" data-id="element-72">
                  Phone Number
                </label>
                <input type="tel" id="phone" className="w-full bg-transparent border-0 border-b border-neutral-300 py-3 px-0 text-primary font-light focus:outline-none focus:border-accent transition-colors placeholder:text-neutral-400 rounded-none" placeholder="+63 917 123 4567" data-id="element-73" />
              </div>

              <div className="space-y-2" data-id="element-74">
                <label htmlFor="service" className="text-xs uppercase tracking-widest text-text-muted font-light" data-id="element-75">
                  Service of Interest
                </label>
                <select id="service" className="w-full bg-transparent border-0 border-b border-neutral-300 py-3 px-0 text-primary font-light focus:outline-none focus:border-accent transition-colors appearance-none rounded-none" data-id="element-76">
                  <option value="" data-id="element-77">Select a service</option>
                  <option value="architecture" data-id="element-78">Architecture Design</option>
                  <option value="interior" data-id="element-79">Interior Design</option>
                  <option value="project-management" data-id="element-80">Project Management</option>
                  <option value="construction" data-id="element-81">Construction Management</option>
                </select>
              </div>

              <div className="space-y-2" data-id="element-82">
                <label htmlFor="message" className="text-xs uppercase tracking-widest text-text-muted font-light" data-id="element-83">
                  Project Details
                </label>
                <textarea id="message" rows={4} className="w-full bg-transparent border-0 border-b border-neutral-300 py-3 px-0 text-primary font-light focus:outline-none focus:border-accent transition-colors placeholder:text-neutral-400 resize-none rounded-none" placeholder="Tell us about your vision..." data-id="element-84"></textarea>
              </div>

              <button type="submit" className="w-full bg-accent text-white font-light uppercase tracking-widest py-4 rounded-sm hover:bg-accent/90 transition-colors duration-300 mt-4" data-id="element-85">
                Submit Inquiry
              </button>
            </form>
          </motion.div>
        </div>
      </div>
    </section>;
}